<template>
  <transition name="c-head--anim">
  <div v-show="isShow" class="c-head">
    <div class="c-head__logo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 27" width="130" height="27">
        <g>
          <title>dhu</title>
          <path fill-rule="evenodd" fill="rgb(0, 0, 0)" d="M129.860,10.420 L125.763,23.572 C125.327,24.963 123.774,26.102 122.304,26.102 L90.923,26.102 C89.455,26.102 88.608,24.963 89.039,23.572 L93.134,10.420 C93.572,9.028 95.129,7.888 96.599,7.888 L104.357,7.888 C105.827,7.888 106.671,9.028 106.241,10.420 L103.759,18.378 C103.323,19.766 104.172,20.904 105.642,20.904 L113.440,20.904 C114.912,20.904 116.467,19.766 116.901,18.378 L119.375,10.420 C119.810,9.028 121.368,7.888 122.840,7.888 L127.976,7.888 C129.450,7.888 130.293,9.028 129.860,10.420 ZM81.459,23.572 C81.028,24.963 79.469,26.102 77.997,26.102 L72.863,26.102 C71.391,26.102 70.545,24.963 70.979,23.572 L73.446,15.648 C73.880,14.252 73.030,13.116 71.560,13.116 L63.770,13.116 C62.299,13.116 60.740,14.252 60.311,15.648 L57.839,23.572 C57.408,24.963 55.848,26.102 54.378,26.102 L46.626,26.102 C45.148,26.102 44.303,24.963 44.742,23.572 L51.261,2.627 C51.693,1.235 53.252,0.091 54.727,0.091 L62.485,0.091 C63.953,0.091 64.802,1.235 64.364,2.627 L63.515,5.350 C63.084,6.748 63.927,7.890 65.401,7.894 L83.659,7.914 C85.129,7.919 85.977,9.059 85.545,10.455 L81.459,23.572 ZM36.858,23.572 C36.424,24.963 34.864,26.102 33.394,26.102 L2.020,26.102 C0.550,26.102 -0.295,24.963 0.134,23.572 L4.220,10.455 C4.658,9.059 6.215,7.922 7.687,7.922 L25.957,7.922 C27.427,7.922 28.982,6.782 29.420,5.391 L30.275,2.627 C30.715,1.235 32.271,0.092 33.739,0.092 L41.497,0.092 C42.969,0.092 43.818,1.235 43.379,2.627 L36.858,23.572 ZM24.338,13.116 L16.545,13.116 C15.075,13.116 13.520,14.252 13.082,15.648 L12.233,18.377 C11.802,19.766 12.649,20.907 14.121,20.907 L21.912,20.907 C23.376,20.907 24.937,19.766 25.371,18.377 L26.224,15.648 C26.658,14.252 25.811,13.116 24.338,13.116 Z"/>
        </g>
      </svg>
    </div>
    <hr class="c-head__bar" />
    <h1 class="c-head__title">DHU 2025 AGENDA</h1>
    <div class="c-head__btn" @click="open">
      <div class="c-btnNav">
        <div class="c-btnNav__wrap">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { breakpoint, assets_path } from '@/_constant/variables';
  import store from '@/_modules/utils/stores';
  import {gsap, Cubic, Elastic} from 'gsap'

  export default {
    data() {
      return {
        isShow: false,
      }
    },
    store,
    computed: {
    },
    mounted() {
      requestAnimationFrame(this.init);
    },
    methods: {
      init() {
        //window.addEventListener('scroll', this.scroll);
      },
      scroll() {
        const scrollY = this.getScrollTop();
        if (this.headH < scrollY) {
          if (this.isShow) this.isShow = false;
        } else {
          if (!this.isShow) this.isShow = true;
        }
      },
      start() {
        this.isShow = true;
      },
      open() {
        this.$parent.$refs['GlobalNav'].open();
      },
    }
  }
</script>
